<script lang="ts">
    import type { Command } from "./types";

    export let command: Command = undefined!;
    export let hotkey = command?.hotkey ?? "";

    let strokes: string[] = hotkey.split(",").filter(s => s.trim().length > 0);

    function format(key: string) {
        key = key.trim();
        return (
            {
                up: "↑",
                down: "↓",
                left: "←",
                right: "→",
            }[key] ?? key
        );
    }
</script>

{#each strokes as stroke, i}
    {#each stroke.split("+") as key}
        <kbd class="key">{format(key)}</kbd>
    {/each}
    {#if i < strokes.length - 1}
        <span class="or">or</span>
    {/if}
{/each}

<style>
    kbd {
        display: inline-block;
        box-sizing: border-box;
        line-height: 1.1;

        border: 1px solid var(--gap-color);
        border-radius: 2px;
        padding: 0.2em 0.5em;
        font-family: var(--font-monospace);
        font-size: 0.8em;
        user-select: none;

        white-space: pre;
        background: var(--g100);
    }

    .key + .key {
        margin-left: 0.25em;
    }

    .or {
        font-size: 0.8em;
        margin-inline: 0.5em;
        font-family: var(--font-monospace);
        user-select: none;
        align-self: center;
    }
</style>
